<template>
    <header class="header" id="header">
        <div id="reloadContent" class="header-l" @click="reloadContent" @mouseover="showSidebarMenu" @mouseleave="hideSidebarMenu">
            <router-link to="/" class="header-logo">
                <img src="/web/images/logo-01.svg" alt="logo">
            </router-link>
        </div>
    </header>
</template>

<script>
  import SvgIcon from './SvgIcon'

  export default {
    components: {
      SvgIcon
    },

    methods: {
      reloadContent () {
        location.reload()
      },

      showSidebarMenu (){
        document.getElementById("selectable-channel").style.left = '0';
      },

      hideSidebarMenu () {
        setTimeout(function() {
          document.getElementById('selectable-channel').style.left = '-19.4vw';
        }, 3000);
      },
    }

   }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/HeaderBar.vue